var __rspack_ns_object = JSON.parse('{"Measurements":"Измерения","Studies":"Исследования"}')